'use client';

import { getOrderLabelFromOrderDetails } from '@velocity-exchange/common';
import { AccountOrder } from '../types';

interface TypeCellProps {
	order: AccountOrder;
}

export function TypeCell({ order }: TypeCellProps) {
	return <>{getOrderLabelFromOrderDetails(order)}</>;
}
